import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { GiftIcon, LightbulbIcon, FileTextIcon } from 'lucide-react';
const bonuses = [{
  icon: LightbulbIcon,
  emoji: '🎁',
  title: '100 ideas virales listas para publicar',
  description: 'Nunca más te quedarás sin saber qué contenido hacer. Simplemente eliges una idea y la ejecutas.'
}, {
  icon: FileTextIcon,
  emoji: '🎁',
  title: '50 guiones virales listos',
  description: 'Estructuras ya pensadas para que no tengas que escribir desde cero. Solo adaptas y publicas.'
}];
export function BonusSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-24 px-6 bg-dark-bg relative overflow-hidden" data-id="element-20">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-accent/3 rounded-full blur-3xl" data-id="element-21" />

      <div className="max-w-5xl mx-auto relative" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-4" data-id="element-23">
          <span className="inline-flex items-center gap-2 bg-accent/10 text-accent text-sm font-semibold px-4 py-2 rounded-full mb-6" data-id="element-24">
            <GiftIcon className="w-4 h-4" data-id="element-25" />
            BONOS INCLUIDOS
          </span>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-3xl md:text-5xl font-serif font-bold text-text-primary mb-4 text-center" data-id="element-26">
          Además, no solo tendrás el sistema…
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl text-text-secondary text-center mb-16" data-id="element-27">
          También tendrás TODO listo para empezar hoy mismo
        </motion.p>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-28">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.6,
            delay: 0.25 + index * 0.15
          }} className="relative p-8 bg-dark-secondary rounded-2xl border border-accent/20 hover:border-accent/40 transition-colors" data-id="element-29">
                {/* Glow effect */}
                <div className="absolute -top-px -left-px -right-px h-px bg-gradient-to-r from-transparent via-accent/30 to-transparent" data-id="element-30" />

                <div className="flex items-center gap-4 mb-5" data-id="element-31">
                  <div className="flex items-center justify-center w-14 h-14 bg-accent/10 rounded-xl" data-id="element-32">
                    <Icon className="w-7 h-7 text-accent" data-id="element-33" />
                  </div>
                  <h3 className="text-xl font-serif font-bold text-text-primary leading-tight" data-id="element-34">
                    <span className="mr-2" data-id="element-35">{bonus.emoji}</span>
                    {bonus.title}
                  </h3>
                </div>

                <p className="text-text-secondary leading-relaxed pl-[74px]" data-id="element-36">
                  {bonus.description}
                </p>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="text-center" data-id="element-37">
          <p className="text-lg md:text-xl text-text-secondary mb-4" data-id="element-38">
            Esto elimina la confusión, la duda y el "no sé por dónde empezar".
          </p>
          <p className="text-xl md:text-2xl text-text-primary font-medium mb-2" data-id="element-39">
            Aquí no vienes a aprender…
          </p>
          <p className="text-2xl md:text-3xl font-serif font-bold text-accent" data-id="element-40">
            vienes a empezar.
          </p>
        </motion.div>
      </div>
    </section>;
}